import { useMemo } from 'react';
import { Tooltip } from 'react-tooltip';
import { MultiSelect } from '../../../../other/MultiSelect';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import {
  REPEAT_EVERY_QUANTITY_OPTIONS,
  REPEAT_EVERY_PERIOD_OPTIONS,
  ARCHIVE_EVERY_QUANTITY_OPTIONS,
  ARCHIVE_EVERY_PERIOD_OPTIONS,
} from './constants';
import { isArray, isDate } from 'lodash';
import DateCalendar from '../../../../calendars/DateCalendar/DateCalendar';

const MandatorySaveSettings = ({
  submission_settings,
  handelSettings,
  errors,
  facilityOptions,
  handelSubmittersSettings,
  handelRemove,
  usersGroupsOptions,
  individualUsersOptions,
  handleRemoveAllowedSubmissionsEditor,
}) => {
  const allowedSubmissionsEditorsOptions = useMemo(() => {
    if (submission_settings.submitters?.individual_users?.length) {
      const usersOptions = submission_settings.submitters.individual_users.map((option) => ({
        ...option,
        type: 'user',
      }));
      const groupsOptions = submission_settings.submitters.user_groups.map((option) => ({
        ...option,
        type: 'group',
      }));
      return [...groupsOptions, ...usersOptions];
    } else if (submission_settings.submitters?.user_groups?.length) {
      return submission_settings.submitters.user_groups.map((option) => ({
        ...option,
        type: 'group',
      }));
    } else if (submission_settings.submitters?.facilities?.length) {
      return submission_settings.submitters.facilities.map((option) => ({
        ...option,
        type: 'facility',
      }));
    }

    return [];
  }, [
    submission_settings.submitters.individual_users,
    submission_settings.submitters.user_groups,
    submission_settings.submitters.facilities,
  ]);

  const getRepeatEveryQuantityOptions = () => {
    if (!submission_settings?.recurrent_initiation_repeat_every_period) {
      return [];
    }

    if (submission_settings.recurrent_initiation_repeat_every_period.value === 'yearly') {
      return REPEAT_EVERY_QUANTITY_OPTIONS.filter((item) => item.value <= 4);
    } else if (submission_settings.recurrent_initiation_repeat_every_period.value === 'monthly') {
      return REPEAT_EVERY_QUANTITY_OPTIONS.filter((item) => item.value <= 11);
    } else if (submission_settings.recurrent_initiation_repeat_every_period.value === 'weekly') {
      return REPEAT_EVERY_QUANTITY_OPTIONS.filter((item) => item.value <= 4);
    } else if (submission_settings.recurrent_initiation_repeat_every_period.value === 'daily') {
      return REPEAT_EVERY_QUANTITY_OPTIONS.filter((item) => item.value <= 10);
    }

    return [];
  };

  const getArchiveEveryQuantityOptions = () => {
    if (!submission_settings.recurrent_initiation_archive_period) {
      return [];
    }

    if (submission_settings.recurrent_initiation_archive_period.value === 'yearly') {
      return ARCHIVE_EVERY_QUANTITY_OPTIONS.filter((item) => item.value <= 4);
    } else if (submission_settings.recurrent_initiation_archive_period.value === 'monthly') {
      return ARCHIVE_EVERY_QUANTITY_OPTIONS.filter((item) => item.value <= 11);
    } else if (submission_settings.recurrent_initiation_archive_period.value === 'weekly') {
      return ARCHIVE_EVERY_QUANTITY_OPTIONS.filter((item) => item.value <= 4);
    } else if (submission_settings.recurrent_initiation_archive_period.value === 'daily') {
      return ARCHIVE_EVERY_QUANTITY_OPTIONS.filter((item) => item.value <= 10);
    }

    return [];
  };

  return (
    <>
      <div className="form-control-item-settings">
        <div className="form-settings-label">
          <label className="form-label form-label-big">Define form submitters</label>
          <span>Specify users (facilities and / or user groups / individual users)</span>
        </div>
        <div className="form-settings-inputs">
          <div className="form-settings-inputs">
            <div className={`form-item form-item-select mb-4`}>
              <label className="form-label form-label-big">Facility</label>
              <div className="select-multy-wrapper">
                <span className="select-placeholder">Choose one or several facilities</span>
                <MultiSelect
                  isDisabled={!facilityOptions.length}
                  options={facilityOptions}
                  value={submission_settings.submitters.facilities}
                  onChange={(e) => handelSubmittersSettings(e, 'facilities')}
                  placeholder=""
                  allName="All facilities"
                />
                {submission_settings.submitters?.facilities?.length > 0 && (
                  <>
                    <ul>
                      {submission_settings.submitters.facilities.map((item, key) => (
                        <li key={key}>
                          {item.label}
                          <button className="btn btn-icon" onClick={() => handelRemove('facilities', item)}>
                            <img src="/images/x-circle.svg" alt="" />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>

              <span className="form-error mb-2 d-flex">
                {errors?.submitters && isArray(errors?.submitters) && errors?.submitters[0]
                  ? errors?.submitters[0]
                  : errors?.submitters?.facilities && errors?.submitters?.facilities[0]}
              </span>
            </div>

            <div className={`form-item form-item-select mb-4`}>
              <label className="form-label form-label-big">User groups</label>
              <div className="select-multy-wrapper">
                <span className="select-placeholder">Choose one or several user groups</span>
                <MultiSelect
                  isDisabled={!usersGroupsOptions.length}
                  options={usersGroupsOptions}
                  value={submission_settings.submitters.user_groups}
                  onChange={(e) => handelSubmittersSettings(e, 'user_groups')}
                  placeholder=""
                  allName="All user groups"
                ></MultiSelect>
                {submission_settings.submitters?.user_groups?.length > 0 && (
                  <>
                    <ul>
                      {submission_settings.submitters.user_groups.map((item, key) => (
                        <li key={key}>
                          {item.label}
                          <button className="btn btn-icon" onClick={() => handelRemove('user_groups', item)}>
                            <img src="/images/x-circle.svg" alt="" />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
              <span className="form-error mb-2 d-flex">{errors?.submitters?.user_groups && errors?.submitters?.user_groups[0]}</span>
            </div>

            <div className={`form-item form-item-select mb-4`}>
              <label className="form-label form-label-big">Individual Users</label>
              <div className="select-multy-wrapper">
                <span className="select-placeholder">Choose one or several individual_users</span>
                <MultiSelect
                  isDisabled={!individualUsersOptions.length}
                  options={individualUsersOptions}
                  value={submission_settings.submitters.individual_users}
                  onChange={(e) => handelSubmittersSettings(e, 'individual_users')}
                  placeholder=""
                  allName="All individual users"
                ></MultiSelect>
                {submission_settings.submitters?.individual_users?.length > 0 && (
                  <>
                    <ul className={'individual-users-list'}>
                      {submission_settings.submitters.individual_users
                        .sort(function (a, b) {
                          if (a.label < b.label) {
                            return -1;
                          }
                          if (a.label > b.label) {
                            return 1;
                          }
                          return 0;
                        })
                        .map((item, key) => (
                          <li key={key}>
                            {item.label}
                            <button className="btn btn-icon" onClick={() => handelRemove('individual_users', item)}>
                              <img src="/images/x-circle.svg" alt="" />
                            </button>
                          </li>
                        ))}
                    </ul>
                  </>
                )}
                <span className="form-error mb-2 d-flex">
                  {errors?.submitters?.individual_users && errors?.submitters?.individual_users[0]}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="form-control-item-settings">
        <div className="form-settings-label">
          <label className="form-label form-label-big">Can Submitters Edit Previous Submissions?</label>
          <span>Determine whether submitters will have the capability to edit their previous submission?</span>
        </div>
        <div className="form-settings-inputs">
          <div className="d-flex">
            <div className={`form-control-radio`}>
              <input
                name="can_edit_previous_submission"
                type="radio"
                onChange={() => handelSettings(true, 'can_edit_previous_submission')}
                checked={submission_settings.can_edit_previous_submission}
              />
              <span>Yes</span>
              <i className="icon-icon-info ml-2" data-tooltip-id={`table-tooltip-can_edit_previous_submission`}></i>
              <Tooltip opacity={1} id={`table-tooltip-can_edit_previous_submission`} place="bottom">
                The form submitter can edit previous submissions, added by them or other submitters
              </Tooltip>
            </div>
            <div className={`form-control-radio`}>
              <input
                name="can_edit_previous_submission"
                type="radio"
                onChange={() => handelSettings(false, 'can_edit_previous_submission')}
                checked={!submission_settings.can_edit_previous_submission}
              />
              <span>No</span>
              <i className="icon-icon-info ml-2" data-tooltip-id={`table-tooltip-can_edit_previous_submission-false`}></i>
              <Tooltip opacity={1} id={`table-tooltip-can_edit_previous_submission-false`} place="bottom">
                The form submitter can edit previous submissions, added by them or other submitters
              </Tooltip>
            </div>
          </div>
          <span className="form-error mb-2 d-flex">{errors?.can_edit_previous_submission && errors?.can_edit_previous_submission[0]}</span>
        </div>
      </div>

      {submission_settings.can_edit_previous_submission && (
        <div className="form-control-item-settings">
          <div className="form-settings-label">
            <label className="form-label form-label-big">Define who can edit previous submissions</label>
            <span>You can select one or multiple form submitters who can edit previous submissions</span>
          </div>
          <div className="form-settings-inputs">
            <div className={`form-item form-item-select mb-4`}>
              <label className="form-label form-label-big">Select</label>
              <div className="select-multy-wrapper">
                <span className="select-placeholder">Select</span>
                <MultiSelect
                  options={allowedSubmissionsEditorsOptions}
                  value={submission_settings.allowed_submissions_editors}
                  onChange={(e) => handelSettings(e, 'allowed_submissions_editors')}
                  placeholder="Select"
                  allName="All"
                  menuPlacement="top"
                ></MultiSelect>
                {submission_settings.allowed_submissions_editors?.length > 0 && (
                  <>
                    <ul>
                      {submission_settings.allowed_submissions_editors.map((item, key) => (
                        <li key={key}>
                          {item.label}
                          <button className="btn btn-icon" onClick={() => handleRemoveAllowedSubmissionsEditor(item)}>
                            <img src="/images/x-circle.svg" alt="" />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
              <span className="form-error mb-2 d-flex">
                {errors?.allowed_submissions_editors && errors.allowed_submissions_editors.non_field_errors[0]}
              </span>
            </div>
          </div>
        </div>
      )}

      <div className={'form-control-item-settings'}>
        <div className="form-settings-label">
          <label className="form-label form-label-big">Recurrent initiation</label>
          <span>Selecting "Yes" generates a duplicate of this form within your "Forms available to me" folder.</span>
        </div>
        <div className="form-settings-inputs">
          <div className="d-flex mb-2">
            <div className={`form-control-radio`}>
              <input
                type="radio"
                name="recurrent-initiation"
                checked={!!submission_settings.recurrent_initiation}
                onChange={() => handelSettings(true, 'recurrent_initiation')}
              />
              <span>Yes</span>
            </div>
            <div className={`form-control-radio`}>
              <input
                type="radio"
                name="recurrent-initiation"
                checked={!submission_settings.recurrent_initiation}
                onChange={() => handelSettings(false, 'recurrent_initiation')}
              />
              <span>No</span>
            </div>
          </div>

          {submission_settings.recurrent_initiation && (
            <>
              <div className="d-flex time-select mb-0" style={{ alignItems: 'flex-start', marginTop: '60px' }}>
                <div className={'form-item form-item-select mb-4'} style={{ display: 'inline-flex', flexDirection: 'column' }}>
                  <label className="form-label">Repeat starting day</label>
                  <DateCalendar
                    minDate={new Date()}
                    isClearable
                    selectedDate={submission_settings.recurrent_initiation_start_date}
                    placeholderText="Choose Date"
                    handleChange={(date) => handelSettings(date, 'recurrent_initiation_start_date')}
                  />
                  {errors?.recurrent_initiation_start_date && (
                    <span className="form-error mt-1">{errors.recurrent_initiation_start_date}</span>
                  )}
                </div>
                <div className={'form-item form-item-select mb-4'} style={{ display: 'inline-flex', flexDirection: 'column' }}>
                  <label className="form-label">Repeat till date (optional)</label>
                  <DateCalendar
                    selectedDate={submission_settings.recurrent_initiation_end_date}
                    isClearable
                    placeholderText="Choose Date"
                    minDate={submission_settings.recurrent_initiation_start_date ?? new Date()}
                    handleChange={(date) => handelSettings(date, 'recurrent_initiation_end_date')}
                  />
                  {errors?.recurrent_initiation_end_date && <span className="form-error mt-1">{errors.recurrent_initiation_end_date}</span>}
                </div>
              </div>
              <p
                style={{
                  fontSize: '14px',
                  color: '#667085',
                }}
              >
                Specify the interval
              </p>

              <div className="form-control-item-group mt-4">
                <label className="form-label">Repeat every</label>
                <div className="d-flex gap-3">
                  <div className="form-control-item-half">
                    <Select
                      menuPlacement="top"
                      hideSelectedOptions={false}
                      isSearchable={false}
                      isDisabled={!submission_settings.recurrent_initiation_repeat_every_period}
                      options={getRepeatEveryQuantityOptions()}
                      value={submission_settings.recurrent_initiation_repeat_every_quantity}
                      onChange={(e) => handelSettings(e, 'recurrent_initiation_repeat_every_quantity')}
                      className="form-control-select"
                      placeholder="Select quantity"
                      classNamePrefix="react-select"
                    ></Select>
                    <span className="form-error">
                      {errors?.recurrent_initiation_repeat_every_quantity && errors.recurrent_initiation_repeat_every_quantity[0]}
                    </span>
                  </div>

                  <div className="form-control-item-half">
                    <Select
                      menuPlacement="top"
                      hideSelectedOptions={false}
                      isSearchable={false}
                      options={REPEAT_EVERY_PERIOD_OPTIONS}
                      value={submission_settings.recurrent_initiation_repeat_every_period}
                      onChange={(e) => handelSettings(e, 'recurrent_initiation_repeat_every_period')}
                      className="form-control-select"
                      placeholder="Select period"
                      classNamePrefix="react-select"
                    ></Select>
                    <span className="form-error">
                      {errors?.recurrent_initiation_repeat_every_period && errors.recurrent_initiation_repeat_every_period[0]}
                    </span>
                  </div>
                </div>
              </div>

              <div className="form-item form-item-select form-item-time ">
                <label className="form-label">Repeat starting time</label>
                <DatePicker
                  selected={isDate(submission_settings?.recurrent_initiation_time) ? submission_settings?.recurrent_initiation_time : null}
                  onChange={(date) => handelSettings(date, 'recurrent_initiation_time')}
                  className={'form-control'}
                  showTimeSelect
                  showTimeSelectOnly
                  isClearable
                  placeholderText={'Choose Time'}
                  timeIntervals={60}
                  timeCaption=""
                  dateFormat="h:mm aa"
                />
                {errors?.recurrent_initiation_time && <span className="form-error mb-2">{errors.recurrent_initiation_time[0]}</span>}
              </div>
            </>
          )}
        </div>
      </div>

      <div className={'form-control-item-settings'}>
        <div className="form-settings-label">
          <label className="form-label form-label-big">Should the form be automatically archived?</label>
          <span>
            This form will be automatically archived from the moment it appears in the Forms available to me folder after specified period.
          </span>
        </div>
        <div className="form-settings-inputs">
          <div className="d-flex mb-2">
            <div className={`form-control-radio`}>
              <input
                type="radio"
                name="recurrent-initiation-should-be-archived"
                checked={!!submission_settings.recurrent_initiation_should_be_archived}
                onChange={() => handelSettings(true, 'recurrent_initiation_should_be_archived')}
              />
              <span>Yes</span>
            </div>
            <div className={`form-control-radio`}>
              <input
                type="radio"
                name="recurrent-initiation-should-be-archived"
                checked={!submission_settings.recurrent_initiation_should_be_archived}
                onChange={() => handelSettings(false, 'recurrent_initiation_should_be_archived')}
              />
              <span>No</span>
            </div>
          </div>

          {submission_settings.recurrent_initiation_should_be_archived && (
            <>
              <p style={{ color: '#667085', fontSize: '14px', marginTop: '60px' }}>
                Specify the period from the date when the copy was created
              </p>
              <div className="form-control-item-group mt-4">
                <div className="d-flex gap-3">
                  <div className="form-control-item-half">
                    <Select
                      menuPlacement="top"
                      hideSelectedOptions={false}
                      isSearchable={false}
                      isDisabled={!submission_settings.recurrent_initiation_archive_period}
                      options={getArchiveEveryQuantityOptions()}
                      value={submission_settings.recurrent_initiation_archive_quantity}
                      onChange={(e) => handelSettings(e, 'recurrent_initiation_archive_quantity')}
                      className="form-control-select"
                      placeholder="Select quantity"
                      classNamePrefix="react-select"
                    ></Select>
                    <span className="form-error">
                      {errors?.recurrent_initiation_archive_quantity && errors.recurrent_initiation_archive_quantity[0]}
                    </span>
                  </div>

                  <div className="form-control-item-half">
                    <Select
                      menuPlacement="top"
                      hideSelectedOptions={false}
                      isSearchable={false}
                      options={ARCHIVE_EVERY_PERIOD_OPTIONS}
                      value={submission_settings.recurrent_initiation_archive_period}
                      onChange={(e) => handelSettings(e, 'recurrent_initiation_archive_period')}
                      className="form-control-select"
                      placeholder="Select period"
                      classNamePrefix="react-select"
                    ></Select>
                    <span className="form-error">
                      {errors?.recurrent_initiation_archive_period && errors.recurrent_initiation_archive_period[0]}
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MandatorySaveSettings;
